import React, { useId } from "react";
import { RiHome3Line } from "react-icons/ri";
import styles from "./ButtonHome.module.css";
import classNames from "classnames";
import { TooltipTemplate } from "UiKit";
function ButtonHome({ defaultHash }) {
    const id = useId();
    if (!defaultHash)
        return null;
    return (React.createElement("div", null,
        React.createElement("a", { className: classNames(styles["btn-back"], !defaultHash && styles.disabled), href: defaultHash, id: id },
            React.createElement(RiHome3Line, null)),
        React.createElement(TooltipTemplate, { id: id, position: "right" },
            React.createElement("span", null, "\u0413\u043B\u0430\u0432\u043D\u0430\u044F"))));
}
export default ButtonHome;
